import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Selvarajan</h3>
            <p>Full Stack Developer</p>
          </div>
          <div className="footer-social">
            <a href="https://github.com/selvarajane" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github"></i>
            </a>
            <a href="https://www.linkedin.com/in/selvarajane" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="mailto:selvarajanoutlook@gmail.com">
              <i className="fas fa-envelope"></i>
            </a>
            <a href="https://wa.me/919600295627" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} Selvarajan. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
